import appCheckDetails from './images/app-check-details.webp'
import appCodeLink from './images/app-code-link.webp'
import appSignUp from './images/app-sign-up.webp'
import emailAppLinks from './images/email-app-links.webp'
import emailConsumptionButton from './images/email-consumption-button.webp'
import webCheckDetails from './images/web-check-details.webp'

export const HELP_IMAGES = {
  appCheckDetails,
  appCodeLink,
  appSignUp,
  emailAppLinks,
  emailConsumptionButton,
  webCheckDetails,
}
